export const ADMIN_ADDRESS = "BpFwraEVEirHhFx2b9JxHqiUKXbp6k3CYtUVTVWggdDP";
export const PROJECT_VAULT_ADDRESS = "C8EviamJHF2Up5rC16iuXKrf931Q9QyBecW1Bjgd4PR9";
export const SOL = "solana";
export const USDC = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const FEE_WALLET = "8igegUKpCGHhmKzWhmheCCFYw4tEj7Hp9doggTQDs6UB";
export const BONK = "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263";
export const SKR = "SKRbvo6Gf7GondiT3BbTfuRDPqLWei4j2Qy2NPGZhW3";
export const MEW = "MEW1gQWJ3nEXg2qgERiKu7FAFj79PHvQVREQUzScPP5";
export const ANGELIC_SOL = "3UAjbnd4w7MJstT3HjnyKBXZeiKUNU83cBL1ouDspump";
export const GMT = "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx";
export const DRAGON = "A8vhvkq9yB3aJR16XrF1rsgakhVnaaoPFKW8Me2jpump";